import { createContext, useContext, useEffect, useMemo, useState, useCallback } from 'react';

const NativeTabContext = createContext({
  tab: 'home',
  setTab: () => {},
});

export const NATIVE_TABS = ['home', 'paper', 'stories', 'you'];

export function NativeTabProvider({ children, initialTab = 'home' }) {
  const [tab, setTab] = useState(initialTab);

  useEffect(() => {
    const onTab = (e) => {
      const next = e.detail?.tab;
      if (NATIVE_TABS.includes(next)) setTab(next);
    };
    window.addEventListener('rk-native-tab', onTab);
    return () => window.removeEventListener('rk-native-tab', onTab);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [tab]);

  const value = useMemo(() => ({ tab, setTab }), [tab]);
  return <NativeTabContext.Provider value={value}>{children}</NativeTabContext.Provider>;
}

export function useNativeTab() {
  return useContext(NativeTabContext);
}

export function goNativeTab(tab) {
  window.dispatchEvent(new CustomEvent('rk-native-tab', { detail: { tab } }));
}

export function openNativeStory(id) {
  window.dispatchEvent(new CustomEvent('rk-open-story', { detail: { id } }));
}
